import React, { Component } from 'react'

import WorkOrderView from './WorkOrderView'

class WorkOrderEditor extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <WorkOrderView {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

export default WorkOrderEditor



// WEBPACK FOOTER //
// ./src/components/WorkOrderEditor.js